import { makeStyles, styled } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";
import { VscInfo } from "react-icons/vsc";

export const HeaderCard = styled("div")(() => ({
  borderRadius: "8px",
  border: "1px",
  height: "172px",
  backgroundColor: "#F1F6FB",
}));

export const HeaderContainer = styled("div")(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",

  backgroundColor: "#F1F6FB",
  borderRadius: "8px",
  border: "1px",

  "@media (min-width: 600px)": {
    flexDirection: "row",
  },
}));

export const ShipContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  alignSelf: "stretch",

  backgroundColor: "#3377B6",
  borderTopRightRadius: "8px",
  borderTopLeftRadius: "8px",
  width: "100%",

  "@media (min-width: 600px)": {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",

    borderBottomLeftRadius: "8px",
    borderTopRightRadius: "0px",
    maxWidth: "160px",
  },
}));

export const HeaderImage = styled("img")(() => ({
  height: "100px",
  maxWidth: "124px",

  "@media (min-width: 600px)": {
    height: "108px",
  },
}));

export const InfoContainer = styled("div")(() => ({
  display: "flex",
  gap: "0 8px",

  height: "100%",
  padding: "16px 24px",

  "@media (min-width: 600px)": {
    flexDirection: "column",
    width: "100%",
  },
}));

interface ShipStatusProps {
  color?: string;
  backgroundColor?: string;
  borderBottomLeftRadius?: string;
  borderBottomRightRadius?: string;
  borderTopRightRadius?: string;
  borderTopLeftRadius?: string;
  height?: string;
  delayedDays?: number;
}

export const ShipStatus = styled("div")(
  ({
    color = "#F1F6FB",
    backgroundColor = "#004D9580",
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopRightRadius,
    borderTopLeftRadius,
    height,
    delayedDays,
  }: ShipStatusProps) => ({
    backgroundColor,
    color,
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopRightRadius,
    borderTopLeftRadius,
    height: height || "68px",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    textAlign: "center",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "@media (min-width: 600px)": {
      borderBottomLeftRadius: delayedDays ? borderBottomLeftRadius : "8px",
    },

    "&#status": {
      borderTopRightRadius: "8px",
      padding: "8px 16px",
      height: "100%",

      "@media (min-width: 600px)": {
        borderTopRightRadius: "0px",
        maxHeight: "48px",
        height: "100%",
        padding: "8px 16px",
        width: "100%",
      },
    },

    "&#delay": {
      height: "32px",
      padding: "8px 16px",

      "@media (min-width: 600px)": {
        borderTopRightRadius: "0px",
        borderBottomLeftRadius: "8px",
        width: "100%",
      },
    },
  })
);

interface DateLabelProps {
  active?: boolean;
  light?: boolean;
}

export const DateLabel = styled("span")(({ active, light }: DateLabelProps) => ({
  color: active ? colors.brandBlue600 : colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: light ? 600 : 700,
  letterSpacing: "0.4px",
  maxWidth: "180px",
}));

export const DateLabelSubtitle = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  letterSpacing: "0.4px",
  maxWidth: "180px",
  display: "flex",
}));

export const ShipmentPrediction = styled("div")(() => ({
  "&#mobilePredictionsComponent": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",

    "@media (min-width: 600px)": {
      display: "none",
    },
  },

  "&#desktopPredictionsComponent": {
    display: "none",

    "@media (min-width: 600px)": {
      display: "flex",
      flexDirection: "row",
      gap: "8px 0",
      justifyContent: "space-between",
    },
  },
}));

export const ShipmentPredictionsBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",

  "@media screen and (max-width: 600px)": {
    gap: 8,
  },
}));

export const IconContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // marginLeft: "4px",
}));

export const InfoIcon = styled(VscInfo)(() => ({
  color: "#475467",
}));

interface TrackingInfosProps {
  height?: string;
}
export const TrackingInfos = styled("div")(({ height }: TrackingInfosProps) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",

  height: "100px",
  maxWidth: "160px",
  width: "100%",

  "@media (min-width: 600px)": {
    display: "flex",
    flexDirection: "column",

    height: height || "64px",
  },
}));

export const useStyles = makeStyles(() => ({
  portsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "44px 0",
    justifyContent: "space-between",

    paddingLeft: "16px",
    minHeight: "320px",

    "@media (min-width: 600px)": {
      flexDirection: "row",
      gap: "0px",

      height: "100%",
      minHeight: "0px",
      paddingLeft: "0px",
      width: "100%",
    },
  },
  trackingInfos: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",

    height: "100px",
    maxWidth: "160px",
    width: "100%",

    "@media (min-width: 600px)": {
      display: "flex",
      flexDirection: "column",

      height: "64px",
    },
  },
  atdMobile: {
    display: "flex",
    flexDirection: "column",

    "@media (min-width: 600px)": {
      display: "none",
    },
  },
  atdDesktop: {
    display: "none",

    "@media (min-width: 600px) and (max-width: 980px)": {
      display: "flex",
      flexDirection: "column",
    },

    "@media (min-width: 980px)": {
      display: "flex",
      flexDirection: "row",
      gap: "0 2px",
    },
  },
  imgContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  airImgContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",

    "@media (min-width: 600px)": {
      position: "relative",
      display: "block",
    },
  },
  shipmentPredictions: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",

    "@media (min-width: 980px)": {
      alignItems: "flex-end",
      gap: "4px",
    },
  },
  shipmentActualDates: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",

    "@media (min-width: 980px)": {
      alignItems: "flex-start",
      gap: "4px",
    },
  },
  predictionsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "0 2px",

    "@media (min-width: 980px)": {
      justifyContent: "flex-end",
      flexDirection: "row",
    },
  },
  tooltip: {
    display: "none",

    "@media (min-width: 980px)": {
      display: "flex",
      marginRight: "4px",
    },
  },
  imgPlane: {
    position: "relative",
    height: "69px",

    "@media (min-width: 600px)": {
      position: "absolute",
      top: "50%",
      right: "12px",
      transform: "translateY(-34.5px)",
    },
  },
}));
